import React, { useEffect, useState } from 'react'
import styles from '../dsNotifications.jcss'
import translate from '../../../core/translate'
import { Header } from '../__header/Header'
import { cn } from 'ethcss'
import { UnitAdd } from '../__unitAdd/UnitAdd'
import Icon from '../../../blocks.simple/icon/icon'
import Checkbox from '../../../blocks.simple/checkbox/checkbox'
import Button from '../../../blocks.simple/button/button'
import { Search } from '../__search/Search'
import { api } from '../../../core/api/ConnectionManager'
import helpers from '../../../core/helpers'

interface IUnit {
    id: number
    unitName: string
    floorList: {
        id: number
        name: string
        digitalSignages: {
            id: number
            name: string
        }[]
    }[]
    officeCode: string
    unitCode: string
    //content: any
    status?: number
}

// const mockList = [
//     {
//         id: 2,
//         unitName: 'Пожарный отсек-2',
//         floorList: [
//             {
//                 id: 2,
//                 name: '2',
//                 digitalSignages: [
//                     {
//                         id: 1,
//                         name: 'android',
//                     },
//                 ],
//             },
//             {
//                 id: 2,
//                 name: '2',
//                 digitalSignages: [
//                     {
//                         id: 2,
//                         name: 'webos',
//                     },
//                 ],
//             },
//         ],
//         officeCode: 'Москва, Ленина 45',
//         unitCode: '002',
//         content: {
//             id: 9659,
//             name: 'россия_1.jpg',
//             isDirectory: 0,
//             size: 68823,
//             thumbnail: 'https://develop-api.smartplayer.org/storage/8/thumbnails/f0ff4dac52e4a2b85608.thumbnail.jpg',
//             fileType: 'image',
//             scroll: null,
//             type: 'fs',
//             extension: '.jpg',
//             folderId: 1651,
//             createdAt: '2023-11-30T18:41:23.000Z',
//             updatedAt: '2023-11-30T18:41:23.000Z',
//             description: '',
//             src: 'https://develop-api.smartplayer.org/storage/8/thumbnails/f0ff4dac52e4a2b85608.thumbnail.jpg',
//             duration: null,
//             dynamicDurationQ: false,
//             iFrameAvailable: null,
//             dataLandscapeStatus: null,
//             style: null,
//             width: '1920',
//             height: '1080',
//             displayAs: null,
//             tags: [],
//             videoValidationErrors: null,
//             personalFolderUserId: null,
//             hasSmartFolderRulesQ: false,
//             actions: ['read', 'update', 'delete'],
//             __view: {
//                 selected: false,
//             },
//         },
//     },
// ]

export const Units = () => {
    const [unitList, setUnitList] = useState<IUnit[]>([])
    const [selectedItems, setSelectedItems] = useState<number[]>([])
    const [unitData, setUnitData] = useState<any>(null)
    const [search, setSearch] = useState<string>('')
    const [deleteConfirm, setDeleteConfirm] = useState<any>(null)
    const [multipleDeleteConfirm, setMultipleDeleteConfirm] = useState<boolean>(false)

    useEffect(() => {
        getChannelList(search, null)
    }, [search])

    const getChannelList = (query: string, nextPageToken: any) => {
        const data: any = {}

        if (query) {
            data.query = query
        }

        api.send('getDsNotifications', data).then((res: any) => {
            if (!res && !res.data) return

            setUnitList(res)
        })
    }
    const onSelectItem = (id: number) => {
        if (selectedItems.includes(id)) {
            setSelectedItems(selectedItems.filter((item) => item !== id))
            return
        }

        setSelectedItems([id, ...selectedItems])
    }
    const onDeleteItem = (id: number) => {
        api.send('deleteNotificationUnit', { ids: [id] }).then(() => setDeleteConfirm(null))
    }
    const deleteAllSelected = () => {
        api.send('deleteNotificationUnit', { ids: selectedItems }).then(() => setMultipleDeleteConfirm(false))
    }
    const onCancelDelete = () => {
        setDeleteConfirm(null)
        setMultipleDeleteConfirm(false)
    }
    const onDeleteConfirm = (id: number) => {
        setDeleteConfirm(id)
    }
    const onMultipleDeleteConfirm = () => {
        setMultipleDeleteConfirm(true)
    }
    const selectAll = () => {
        setSelectedItems(unitList.map((unit: IUnit) => unit.id))
    }
    const clearSelection = () => {
        setSelectedItems([])
    }
    const dropdownSelect = (select: any) => {
        if (select.id === 'selectAll') {
            selectAll()
            return
        }

        clearSelection()
    }
    const onAddUnit = () => {
        setUnitData({
            unitName: '',
            //content: null,
            floorList: [],
            officeCode: '',
            unitCode: '',
            //notificationType: 'fire_alert',
        })
    }
    const onEditUnit = (unit: IUnit) => {
        setUnitData(unit)
    }
    const onUnitChange = (field: string, value: any) => {
        if (unitData) {
            setUnitData({
                ...unitData,
                [field]: value,
            })
        }
    }
    const onCloseModal = () => {
        setUnitData(null)
    }
    const getUnitStatus = (status: number | undefined) => {
        switch (status) {
            case 1:
                return styles.active
            case 2:
                return styles.error
            default:
                return ''
        }
    }
    const onSaveUnit = () => {
        if (!unitData) return

        const data: any = {
            unitName: unitData.unitName,
            //contentSourceId: unitData.content ? unitData.content.id : null,
            floorList: unitData.floorList.map((floor: any) => {
                const digitalSignages: any = []
                const groups: any = []

                floor.digitalSignages.forEach((device: any) => {
                    if (device.type === 'group') {
                        groups.push(device)

                        return
                    }

                    digitalSignages.push(device)
                })

                return {
                    id: unitData.id ? floor.id : null,
                    name: floor.name,
                    digitalSignageIds: digitalSignages.map((device: { id: number; name: string }) => device.id),
                    groupIds: groups.map((device: { id: number; name: string }) => device.id),
                }
            }),
            officeCode: unitData.officeCode,
            unitCode: unitData.unitCode,
            //notificationType: unitData.notificationType,
        }

        if (unitData.id) {
            data.id = unitData.id

            api.send('updateNotificationUnit', data).then(onCloseModal)
            return
        }

        api.send('createNotificationUnit', data).then(onCloseModal)
    }
    const onUnitCreated = (unit: IUnit) => {
        setUnitList([...unitList, unit])
    }
    const onUnitUpdated = (unit: IUnit) => {
        setUnitList(
            unitList.map((el: IUnit) => {
                if (el.id === unit.id) {
                    return unit
                }

                return el
            })
        )
    }
    const onUnitDeleted = (res: any) => {
        setUnitList(unitList.filter((unit: IUnit) => !res.includes(unit.id)))
    }
    const getUnitFloorList = (unit: IUnit) => {
        let florListString = ''

        unit.floorList.forEach((floor) => {
            florListString += floor.name + ', '
        })

        return florListString.slice(0, -2)
    }

    useEffect(() => {
        const listenersId: string[] = []
        api.addObserver('notificationUnitCreated', onUnitCreated, listenersId)
        api.addObserver('notificationUnitUpdated', onUnitUpdated, listenersId)
        api.addObserver('notificationUnitDeleted', onUnitDeleted, listenersId)

        return () => listenersId.forEach((id) => api.removeObserver(id))
    }, [unitList])

    return (
        <>
            {/*<Search search={search} setSearch={setSearch} dropdownSelect={dropdownSelect} />*/}
            <div className={cn(styles.wrapper, styles.scrollWrapper)}>
                <Header
                    selectedItemsLength={selectedItems.length}
                    deleteAllSelected={onMultipleDeleteConfirm}
                    onAdd={onAddUnit}
                />
                <table className={styles.tableDisplay}>
                    <tr className={cn(styles.unit, styles.unitsHeader, styles.widthFull)}>
                        {helpers.isAvailableAction(null, {
                            key: 'DSNotifications',
                            action: 'delete',
                        }) && <td className={styles.checkbox}>{translate('choice')}</td>}
                        <td className={styles.unitName}>{translate('unitName')}</td>
                        <td className={styles.floorNumber}>{translate('floors')}</td>
                        <td className={styles.officeCode}>{translate('officeCode')}</td>
                        <td className={styles.unitCode}>{translate('unitCode')}</td>
                        {/*<td className={styles.content}>{translate('content')}</td>*/}
                        <td></td>
                    </tr>
                    {unitList.map((unit: IUnit) => {
                        return (
                            <tr className={cn(styles.unit, getUnitStatus(unit.status))}>
                                {helpers.isAvailableAction(null, {
                                    key: 'DSNotifications',
                                    action: 'delete',
                                }) && (
                                    <td className={styles.checkbox}>
                                        <span>
                                            <Checkbox
                                                checked={selectedItems.includes(unit.id)}
                                                onClick={() => onSelectItem(unit.id)}
                                            />
                                        </span>
                                    </td>
                                )}
                                <td className={styles.unitName}>{unit.unitName}</td>
                                <td className={styles.floorNumber}>{getUnitFloorList(unit)}</td>
                                <td className={styles.officeCode}>{unit.officeCode}</td>
                                <td className={styles.unitCode}>{unit.unitCode}</td>
                                {/*<td className={styles.unitContent}>*/}
                                {/*    {unit.content ? <img className={styles.contentImg} src={unit.content.src} /> : null}*/}
                                {/*</td>*/}
                                <td className={styles.changeButtonsWrapper}>
                                    <div className={styles.changeButtons}>
                                        {helpers.isAvailableAction(null, {
                                            key: 'DSNotifications',
                                            action: 'update',
                                        }) && (
                                            <div>
                                                <Icon type={'pencil'} onClick={() => onEditUnit(unit)} />
                                            </div>
                                        )}
                                        {helpers.isAvailableAction(null, {
                                            key: 'DSNotifications',
                                            action: 'delete',
                                        }) && (
                                            <div>
                                                <Icon type={'delete'} onClick={() => onDeleteConfirm(unit.id)} />
                                            </div>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </table>
            </div>
            <UnitAdd unit={unitData} onChange={onUnitChange} onClose={onCloseModal} onSave={onSaveUnit} />
            {(deleteConfirm || multipleDeleteConfirm) && (
                <div className={styles.deleteConfirmWrapper}>
                    <div className={styles.deleteConfirm}>
                        <div>{translate(deleteConfirm ? 'deleteUnitConfirm' : 'deleteUnitsConfirm')}</div>
                        <div className={styles.controls}>
                            <Button mod={'withBorder'} className={styles.button} onClick={onCancelDelete}>
                                {translate('cancel')}
                            </Button>
                            <Button
                                mod={'fill'}
                                className={styles.button}
                                onClick={() => (deleteConfirm ? onDeleteItem(deleteConfirm) : deleteAllSelected())}
                            >
                                {translate('delete')}
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
